import React, { useEffect } from "react";
import { resetAllSentEmails, resetScheduledEmails } from "../actions";
import EmailEditionsWrapper from "./EmailEditionsWrapper";
import ScheduledEditions from "./ScheduledEditions";

function SentEditionsPage() {
  useEffect(() => {
    return () => {
      resetAllSentEmails();
      resetScheduledEmails();
    };
  }, []);

  return (
    <React.Fragment>
      <ScheduledEditions noEmptyMessage scheduledStyle />
      <EmailEditionsWrapper title={"All Emails"} />
    </React.Fragment>
  );
}

export default SentEditionsPage;
